const cards = {
    "title": "My works",
    "contents": [
        {
            "title": "PRIDE AND PREJUDICE",
            "subtitle": "By Jane Austen",
            "texts": [
                `It is a truth universally acknowledged, that a single man in possession of a good fortune, must be in want of a wife.`,
                `However little known the feelings or views of such a man may be on his first entering a neighbourhood, this truth is so well fixed in the minds of the surrounding families, that he is considered the rightful property of some one or other of their daughters.`,
                `“My dear Mr. Bennet,” said his lady to him one day, “have you heard that Netherfield Park is let at last?”`,
                `Mr. Bennet replied that he had not.`,
                `“But it is,” returned she; “for Mrs. Long has just been here, and she told me all about it.”`,
        ],
            "link": "http://www.gutenberg.org/files/1342/1342-0.txt",
        },
        {
            "title": "日本語(Example of multi-bytes languages)",
            "subtitle" : "engineer",
            "texts": [
                "適切なエラーハンドリングの実施。",
                "ユニットテストを書けるよう構造の見直し。",
                "実際にユニットテストを書く。",
                "再設計を行い、ログを除いたコード行数が引き継いだ時点から半分以下にできることを示す。",
                "不要なラッパーを削除し、ログの出力文を短縮することで、コード量を3割減。",
                "上記を通してThroughPutを25%改善。"
            ],
            "link": "https://en-blog.aimof.net"
        },
        {
            "title": "project0",
            "subtitle" : "engineer",
            "texts": [
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext"
            ],
            "link": "https://en-blog.aimof.net"
        },
        {
            "title": "project1",
            "subtitle" : "engineer",
            "texts": [
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext"
            ],
            "link": "https://en-blog.aimof.net"
        },
        {
            "title": "project2",
            "subtitle" : "engineer",
            "texts": [
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext"
            ],
            "link": "https://en-blog.aimof.net"
        },
        {
            "title": "project3",
            "subtitle" : "engineer",
            "texts": [
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext",
                "texttexttexttexttexttexttexttexttexttexttexttext"
            ],
            "link": "https://en-blog.aimof.net"
        },

    ]
}

exports.cards = cards
